import { FiAward } from 'react-icons/fi';

interface ReputationBadgeProps {
  tier: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showLabel?: boolean;
}

const tierConfig: Record<string, { color: string; bgColor: string; borderColor: string; label: string }> = {
  bronze: {
    color: 'text-amber-600',
    bgColor: 'bg-amber-600/20',
    borderColor: 'border-amber-600/50',
    label: 'Bronze'
  },
  silver: {
    color: 'text-gray-300',
    bgColor: 'bg-gray-300/20',
    borderColor: 'border-gray-300/50',
    label: 'Silver'
  },
  gold: {
    color: 'text-yellow-400',
    bgColor: 'bg-yellow-400/20',
    borderColor: 'border-yellow-400/50',
    label: 'Gold'
  },
  diamond: {
    color: 'text-cyan-400',
    bgColor: 'bg-cyan-400/20',
    borderColor: 'border-cyan-400/50',
    label: 'Diamond'
  }
};

const sizeConfig = {
  sm: { icon: 'w-3 h-3', container: 'px-1.5 py-0.5 text-xs', gap: 'gap-1' },
  md: { icon: 'w-4 h-4', container: 'px-2 py-1 text-xs', gap: 'gap-1.5' },
  lg: { icon: 'w-5 h-5', container: 'px-2.5 py-1 text-sm', gap: 'gap-1.5' },
  xl: { icon: 'w-6 h-6', container: 'px-3 py-1.5 text-sm', gap: 'gap-2' }
};

/**
 * ReputationBadge - Displays user's competition tier
 *
 * Tiers: Bronze (0-99 pts) → Silver (100-499) → Gold (500-1999) → Diamond (2000+)
 */
export default function ReputationBadge({
  tier,
  size = 'md',
  showLabel = true
}: ReputationBadgeProps) {
  const config = tierConfig[tier.toLowerCase()] || tierConfig.bronze;
  const sizeStyles = sizeConfig[size];

  return (
    <span
      className={`inline-flex items-center ${sizeStyles.gap} ${sizeStyles.container} ${config.bgColor} ${config.color} border ${config.borderColor} rounded-full font-medium`}
    >
      <FiAward className={sizeStyles.icon} />
      {showLabel && <span>{config.label}</span>}
    </span>
  );
}
